<template>
  <section
    class="copy-link-card"
    :class="{ 'copy-link-card--recommended': recommended }"
  >
    <header class="copy-link-card__header">
      <div>
        <h6 class="copy-link-card__title">{{ title }}</h6>
        <p v-if="description" class="copy-link-card__description">
          {{ description }}
        </p>
      </div>
      <span
        class="copy-link-card__badge"
        :class="{ 'copy-link-card__badge--recommended': recommended }"
      >
        {{ recommended ? "Recomendado" : "Descontinuado" }}
      </span>
    </header>

    <a
      class="copy-link-card__url"
      :href="url"
      :title="url"
      target="_blank"
      rel="noopener"
    >
      {{ url }}
    </a>

    <div class="copy-link-card__actions">
      <button
        type="button"
        class="copy-link-card__button copy-link-card__button--secondary"
        @click="$emit('open', url)"
      >
        Abrir link
      </button>
      <button
        type="button"
        class="copy-link-card__button copy-link-card__button--primary"
        @click="$emit('copy', url)"
      >
        <img src="@/assets/img/icons/copy.svg" alt="" />
        {{ copyLabel }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "CopyLinkCard",
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    copyLabel: {
      type: String,
      default: "Copiar link",
    },
    recommended: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.copy-link-card {
  padding: 16px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  background: #fff;
}

.copy-link-card + .copy-link-card {
  margin-top: 14px;
}

.copy-link-card--recommended {
  border-color: #b8cff2;
  background: #f4f8ff;
  box-shadow: 0 1px 2px rgba(23, 78, 166, 0.06);
}

.copy-link-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.copy-link-card__title {
  margin: 0 0 3px;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.copy-link-card--recommended .copy-link-card__title {
  color: #174ea6;
}

.copy-link-card__description {
  margin: 0;
  color: #667085;
  font-size: 12px;
  line-height: 18px;
}

.copy-link-card__badge {
  flex: none;
  padding: 2px 8px;
  border-radius: 12px;
  background: #f2f4f7;
  color: #667085;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
}

.copy-link-card__badge--recommended {
  background: #dbeafe;
  color: #174ea6;
}

.copy-link-card__url {
  display: block;
  width: 100%;
  padding: 11px 12px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #f8f9fb;
  color: #475467;
  font-size: 13px;
  line-height: 20px;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: break-word;
}

.copy-link-card__url:hover {
  border-color: #98a2b3;
  color: #174ea6;
  text-decoration: none;
}

.copy-link-card--recommended .copy-link-card__url {
  border-color: #d2def0;
  background: #fff;
}

.copy-link-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.copy-link-card__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 0 13px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.copy-link-card__button--secondary {
  border-color: #d0d5dd;
  background: #fff;
  color: #475467;
}

.copy-link-card__button--secondary:hover {
  background: #f9fafb;
  border-color: #98a2b3;
}

.copy-link-card__button--primary {
  border-color: #174ea6;
  background: #174ea6;
  color: #fff;
}

.copy-link-card__button--primary:hover {
  border-color: #103c82;
  background: #103c82;
}

.copy-link-card__button--primary img {
  width: 14px;
  filter: brightness(0) invert(1);
}

@media screen and (max-width: 576px) {
  .copy-link-card {
    padding: 14px;
  }

  .copy-link-card__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .copy-link-card__button {
    padding: 0 9px;
  }
}
</style>
